import React from 'react';
import classnames from 'classnames';
import { Button as AntdButton, ButtonProps as AntdButtonProps } from 'antd';

import './style.scss';

const PREFIX = 'music';

export interface ButtonProps extends AntdButtonProps {
  green?: boolean;
  loading?: boolean;
}

export default function Button(props: ButtonProps) {
  const { green, type, className, loading, ...rstProps } = props;

  const btnType = rstProps.danger || green ? 'primary' : type;

  return (
    <AntdButton
      {...rstProps}
      type={btnType}
      disabled={loading || rstProps.disabled}
      className={classnames(`${PREFIX}-btn`, { 'green-btn': green, loading }, className)}
    ></AntdButton>
  );
}
